import { render, staticRenderFns } from "./selection-5.vue?vue&type=template&id=1edeaefa&scoped=true&"
import script from "./selection-5.vue?vue&type=script&lang=js&"
export * from "./selection-5.vue?vue&type=script&lang=js&"
import style0 from "./selection-5.vue?vue&type=style&index=0&id=1edeaefa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edeaefa",
  null
  
)

export default component.exports